import { RuleField } from "../models/RuleField";
import { RuleFieldType } from "../models/RuleFieldType";


export type RuleJsonEditorType = 'object' | 'array' | 'string' | 'number' | 'integer' | 'boolean' | 'null';

export type RuleJsonEditorSchema = {
    type: RuleJsonEditorType
    properties: any
    additionalProperties: boolean,
    minProperties?: number,
    not?: any,
    required: Array<string>
}

export class DataCleaningJsonRuleConfigurationService {

    public static getJsonEditorSchemaForField(field: RuleField): RuleJsonEditorSchema {
        if (field == null) throw new Error("field is required!");

        const schema: any = {
            properties: {},
            additionalProperties: true
        };

        const schemaType: RuleJsonEditorType | null = this.getSchemaTypeForFieldType(field.field_type);
        if (schemaType !== null) {
            schema.type = schemaType;
        }

        return schema;
    }

    private static getSchemaTypeForFieldType(fieldType: RuleFieldType | any): RuleJsonEditorType | null {

        switch (fieldType) {
            case RuleFieldType.Text:
                return 'string';
            case RuleFieldType.Number:
                return 'number';
            case RuleFieldType.Boolean:
                return 'boolean';
            case RuleFieldType.Array:
                return 'array';
            case RuleFieldType.Object:
            case RuleFieldType.Rule:
            case RuleFieldType.Json:
                return 'object'
            default:
                return null; //Do not limit the schema.type, useful for fields without a valid type defined

        }

    }


    public static getJsonEditorSchemaForRule(): RuleJsonEditorSchema {
        return {
            type: 'object',
            required: ["type"],
            properties: {
                type: { type: "string" },
                description: { type: "string" }
            },
            additionalProperties: true
        };
    }


}